<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: consultant_id ? 'Ubah Konsultan' : 'Tambah Konsultan' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="font-weight-bold font-size-20 mt-3 mb-5">
            {{ consultant_id ? "Ubah Konsultan" : "Tambah Konsultan" }}
        </div>

        <v-card flat class="mb-10">
            <v-card-title class="border-bottom py-3">
                <div class="font-size-16 black--text">Data Konsultan</div>
            </v-card-title>
            <v-card-text class="pt-5">
                <v-form ref="form" v-model="valid" lazy-validation>
                    <div>
                        <label>
                            Nama Konsultan
                            <span class="red--text">*</span></label
                        >
                        <v-text-field
                            v-model="form.name"
                            placeholder="Masukan Nama Konsultan"
                            outlined
                            dense
                            maxlength="50"
                            :rules="[
                                (v) => !!v || 'Nama Konsultan Wajib Diisi!',
                            ]"
                            required
                            class="mt-1"
                        />
                    </div>

                    <div>
                        <label> Email <span class="red--text">*</span></label>
                        <v-text-field
                            v-model="form.email"
                            placeholder="Masukan Email Konsultan"
                            outlined
                            dense
                            maxlength="50"
                            :disabled="consultant_id"
                            :readonly="consultant_id"
                            :rules="[
                                (v) => !!v || 'Email Konsultan Wajib Diisi!',
                                (v) =>
                                    /.+@.+\..+/.test(v) ||
                                    'Format email harus sesuai!',
                            ]"
                            required
                            class="mt-1"
                        />
                    </div>

                    <div>
                        <label>
                            No. Handphone
                            <span class="red--text">*</span></label
                        >
                        <v-text-field
                            v-model="form.no_handphone"
                            placeholder="Masukan No. Handphone Konsultan"
                            outlined
                            dense
                            maxlength="16"
                            :rules="[
                                (v) =>
                                    !!v ||
                                    'No. Handphone Konsultan Wajib Diisi!',
                            ]"
                            required
                            class="mt-1"
                        />
                    </div>

                    <div>
                        <label>
                            Lama Mengajar
                            <span class="red--text">*</span></label
                        >
                        <v-text-field
                            v-model="form.teaching_duration"
                            placeholder="Masukan Lama Mengajar"
                            outlined
                            dense
                            maxlength="3"
                            :rules="[
                                (v) => !!v || 'Lama Mengajar Wajib Diisi!',
                            ]"
                            required
                            suffix="Tahun"
                            class="mt-1"
                        />
                    </div>

                    <div>
                        <label> Alumni <span class="red--text">*</span></label>
                        <v-text-field
                            v-model="form.university"
                            placeholder="Masukan Alumni Konsultan"
                            outlined
                            dense
                            maxlength="60"
                            :rules="[
                                (v) => !!v || 'Alumni Konsultan Wajib Diisi!',
                            ]"
                            required
                            class="mt-1"
                        />
                    </div>

                    <div>
                        <label>
                            Mata Pelajaran
                            <span class="red--text">*</span>
                        </label>

                        <v-select
                            dense
                            v-model="form.mapel"
                            :items="mapelList"
                            outlined
                            item-text="nama"
                            item-value="id"
                            placeholder="Pilih Mata Pelajaran"
                            multiple
                            :rules="[
                                (v) =>
                                    !!v.length || 'Mata Pelajaran Wajib Diisi!',
                            ]"
                            required
                            chips
                        >
                        </v-select>
                    </div>

                    <div>
                        <label>
                            Status Awal <span class="red--text">*</span></label
                        >

                        <v-radio-group
                            row
                            v-model="form.consultant_status"
                            :rules="[(v) => !!v || 'Status Awal Wajib Diisi!']"
                            required
                        >
                            <v-radio
                                label="Aktif"
                                :value="'1'"
                                class="radio-custom"
                            ></v-radio>

                            <v-radio
                                label="Nonaktif"
                                :value="'0'"
                                class="radio-custom"
                            ></v-radio>
                        </v-radio-group>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions class="py-4 px-5 border-top-1">
                <v-spacer />
                <v-btn depressed class="mr-1" @click="$router.go(-1)">
                    Batal
                </v-btn>

                <v-btn
                    depressed
                    color="blew"
                    class="white--text"
                    :loading="loading"
                    @click="submitProcess()"
                >
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading" />
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import firebase from "firebase";
import axios from "axios";

export default {
    name: "consultant-management-form",

    components: {
        "app-spinner": AppSpinner,
    },

    data() {
        return {
            loading: false,
            isLoading: false,
            form: {
                name: null,
                email: null,
                no_handphone: null,
                teaching_duration: null,
                university: null,
                mapel: [],
                consultant_status: 0,
            },
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    computed: {
        consultant_id() {
            return this.$route.query.id;
        },
    },

    mounted() {
        if (this.consultant_id) {
            this.getDetailConsultant();
        }
    },

    methods: {
        findmapel(data) {
            const found = this.mapelList.find((mapel) => mapel.nama == data);
            return found;
        },

        getDetailConsultant() {
            const url = `${process.env.API_BASE_URL}konsul/admin/get-detail-consultant/${this.consultant_id}`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;
            self.isLoading = true;

            axios
                .get(url, options)
                .then(function (response) {
                    const res = response.data;

                    self.form = res;

                    self.form.consultant_status =
                        res.consultant_status === 1 ? "1" : "0";

                    self.form.teaching_duration = res.years_experience;
                    self.form.mapel = res.mapel.map((e) => e.mapel_id);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },

        submitProcess() {
            if (!this.consultant_id) {
                this.addProcess();
            } else {
                this.editProcess();
            }
        },

        addProcess() {
            const url = `${process.env.API_BASE_URL}account/consultant`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;
            if (self.$refs.form.validate()) {
                self.loading = true;
                const is_active = self.form.is_active === "1" ? 1 : 0;
                self.form.is_active = is_active;

                axios
                    .post(url, self.form, options)
                    .then(function (response) {
                        if (response.data.status === "200") {
                            self.setUserFirebase();

                            self.$store.commit("showAlert", {
                                message: `Data Konsultan Berhasil Ditambahkan`,
                                type: "success",
                            });

                            self.$router.push("/konsul/management");
                        } else {
                            self.$store.commit("showAlert", {
                                message: `Gagal menambahkan data konsultan, email yang anda masukan mungkin sudah terdaftar`,
                                type: "error",
                            });
                        }
                    })
                    .catch(() => {
                        self.$store.commit("showAlert", {
                            message: `Gagal menambahkan data konsultan, email yang anda masukan mungkin sudah terdaftar`,
                            type: "error",
                        });
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
        },

        editProcess() {
            const url = `${process.env.API_BASE_URL}account/consultant/${this.consultant_id}`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;

            if (self.$refs.form.validate()) {
                self.loading = true;
                const is_active = self.form.is_active === "1" ? 1 : 0;
                self.form.is_active = is_active;

                axios
                    .put(url, self.form, options)
                    .then(function (response) {
                        if (response.data.status === "200") {
                            self.updateUserFirebase();

                            self.$store.commit("showAlert", {
                                message: `Data Konsultan Berhasil Diubah`,
                                type: "success",
                            });

                            self.$router.push("/konsul/management");
                        } else {
                            self.$store.commit("showAlert", {
                                message: `Gagal mengubah data konsultan, email yang anda masukan mungkin sudah terdaftar`,
                                type: "error",
                            });
                        }
                    })
                    .catch(() => {
                        self.$store.commit("showAlert", {
                            message: `Gagal mengubah data konsultan, email yang anda masukan mungkin sudah terdaftar`,
                            type: "error",
                        });
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            }
        },

        setUserFirebase() {
            firebase
                .firestore()
                .collection("consultant_status")
                .doc(this.form.email)
                .set({
                    name: this.form.name,
                    email: this.form.email,
                    is_active: this.form.is_active,
                    status: "offline",
                    mapel: this.form.mapel,
                });
        },

        updateUserFirebase() {
            firebase
                .firestore()
                .collection("consultant_status")
                .doc(this.form.email)
                .update({
                    name: this.form.name,
                    is_active: this.form.is_active,
                    mapel: this.form.mapel,
                });
        },
    },
};
</script>

<style>
.radio-custom {
    background: #fbfbfb;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
    border-radius: 5000px;
}
</style>



// WEBPACK FOOTER //
// ConsultantManagementForm.vue?6db62e46